/* Tracking Target client data model
 *
 * Angular Module: trackerbase-app.models.tracker
 * Injected Factory: Tracker
 */

const mTbServerBaseUrl = new WeakMap();

import makePropsEnumerable from "../utility/MakePropsEnumerable";

function checkRequiredString(strToCheck) {
    return ((!angular.isUndefined(strToCheck)) &&
    (strToCheck != null) &&
    (angular.isString(strToCheck)) &&
    (strToCheck.length > 0));
}

class TrackingTarget {
    constructor(
        targetId,
        firstName,
        lastName,
        candidateElections,
        targetSubscribers,
        tbServerBaseUrl
    )
    {
        mTbServerBaseUrl.set(this, tbServerBaseUrl);

        let validTId = false;
        if (targetId != null)
        {
            let tIdVal = parseInt(targetId);
            if (!isNaN(tIdVal)){
                validTId = true;
                this.trackingTargetId = tIdVal;
            }
        }

        if (validTId !== true) {
            throw new TypeError("Invalid tracking target id");
        }

        if (checkRequiredString(firstName)) {
            this.firstName = firstName;
        }
        else {
            throw new TypeError("Missing or invalid first name.");
        }

        if (checkRequiredString(lastName)) {
            this.lastName = lastName;
        }
        else {
            throw new TypeError("Missing or invalid first name.");
        }

        if (candidateElections != null) {
            this.targetElections = candidateElections.slice();
        }
        else {
            this.targetElections = [];
        }

        this.subscribers = [];
        if (targetSubscribers != null) {

            Array.prototype.push.apply(this.subscribers, targetSubscribers);
        }

        this.detailsUrl = null;


    }

    valueOf() {
        return this.trackingTargetId;
    }
    
    toString() {
        return `${this.lastName}, ${this.firstName}`;
    }
    
    get subscribableId() {
        return this.trackingTargetId;
    }
    
    get targetName() {
        return `${this.firstName} ${this.lastName}`;
    }
    
    get displayName() {
        return this.targetName;
    }
    
    get sortAs() {
        return `${this.lastName}, ${this.firstName}`;
    }
    
    get detailsLocation() {
        if (this.detailsUrl != null) {
            return this.detailsUrl;
        }
        else {
            return `${mTbServerBaseUrl.get(this)}/${this.trackingTargetId}/details`;
        }
    }
    
    set detailsLocation(detUrl) {
        if (detUrl != null) {
            this.detailsUrl = detUrl;
        }
        else {
            this.detailsUrl = null;
        }
    }
    
    getTargetElectionsOnDate(eventDate) {
        return this.targetElections.filter(
            (cElection) => cElection.wasCandidateOnDate(eventDate)
        );
    }
    
    getTargetNextCandidacyAfterDate(eventDate) {
        let postEventCandidacies =
            this.targetElections
                .filter((cElection) => (eventDate <= cElection.startDate))
                .sort(function(cElectionX, cElectionY) {
                    if (cElectionX.startDate < cElectionY.startDate) {
                        return -1;
                    }
                    else if (cElectionX.startDate > cElectionY.startDate) {
                        return 1;
                    }
                    else {
                        return 0; // Must be equal;
                    }
    
                });
    
        if (postEventCandidacies.length > 1) {
            let earliestStartDate = postEventCandidacies[0].startDate;
            let laterStartDateIdx =
                postEventCandidacies.findIndex(
                    (cElection) => (earliestStartDate !== cElection.startDate)
                );

            if (laterStartDateIdx > 0) {
                //truncate out candidacies that start later.
                postEventCandidacies.length = laterStartDateIdx;
            }
        }
    
        return postEventCandidacies;
    }
}

makePropsEnumerable(TrackingTarget.prototype, [
    "detailsLocation",
    "subscribableId",
    "displayName",
    "sortAs",
    "targetName",
    "valueOf",
    "getTargetElectionsOnDate",
    "getTargetNextCandidacyAfterDate"
]);

export default TrackingTarget;




//////////////////
// WEBPACK FOOTER
// ./src/models/TrackingTarget.js
// module id = GwQa
// module chunks = 1